// advent-extra.js — estimated delivery dates for pre-orders (skips weekends)
(function () {
  function addWorkingDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }
  function fmt(d) {
    return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  }
  function run() {
    document.querySelectorAll('[data-adv-eta]').forEach(function (box) {
      var ds = box.dataset;
      var today = new Date();
      var pMin = Number(ds.prodMin), pMax = Number(ds.prodMax);
      [['eu', ds.euMin, ds.euMax], ['us', ds.usMin, ds.usMax]].forEach(function (r) {
        var el = box.querySelector('[data-adv-eta-' + r[0] + ']');
        if (!el || !r[1]) return;
        var from = addWorkingDays(today, pMin + Number(r[1]));
        var to = addWorkingDays(today, pMax + Number(r[2]));
        el.textContent = fmt(from) + ' – ' + fmt(to);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
